import axios from 'axios';
import authHeader from "@/service/auth-header";

class PaymentService {

    async getCompanyPayments(companyId) {
        return await axios.get(`/api/payment1/${companyId}`,{ headers: authHeader() })
    }

    async getCompanyPaymentsLazyLoading(companyId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'paid';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/payment1/lazyloading/${companyId}`;

            console.log("[PaymentService][getCompanyPaymentsLazyLoading] ",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[InvoiceService][getAllPractitionerInvoicesLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }

    async getPractitionerPayments(practitionerId) {
        return await axios.get(`/api/payment1/practitioner/${practitionerId}`,{ headers: authHeader() })
    }

    async getPractitionerPaymentsLazyLoading(companyId, practitionerId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'paid';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/payment1/practitioner/lazyloading/${companyId}/${practitionerId}`;

            console.log("[PaymentService][getPractitionerPaymentsLazyLoading] ",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[InvoiceService][getAllPractitionerInvoicesLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }

    async getPayment(paymentId) {
        return await axios.get(`/api/payment1/specific/${paymentId}`,{ headers: authHeader() })
    }

    async createPayment(companyId, data) {
        return await axios.post(`/api/payment1/${companyId}`, data,{ headers: authHeader() });
    }

    async updatePayment(id, data) {
        return await axios.put(`/api/payment1/${id}`, data,{ headers: authHeader() });
    }

    async allocatePayment(companyId, data) {
        return await axios.post(`/api/payment1/allocation/${companyId}`, data,{ headers: authHeader() });
    }

    async getPaymentDetail(paymentId) {
        return await axios.get(`/api/payment1/allocation/${paymentId}`,{ headers: authHeader() })
    }

    async createPaymentForInvoice(companyId, invoiceId, data) {
        return await axios.post(`/api/payment1/${companyId}/invoice/${invoiceId}`, data,{ headers: authHeader() });
    }

    async createPaymentForInvoiceComponent(companyId, invoiceId, invoiceComponentId, data) {
        return await axios.post(`/api/payment1/${companyId}/invoice/${invoiceId}/component/${invoiceComponentId}`, data,{ headers: authHeader() });
    }

    async deletePayment(paymentId) {
        return await axios.delete(`/api/payment1/${paymentId}`,{ headers: authHeader() })
    }

    async createStripeCheckoutSessionNewClient(priceId, email) {
        return await axios.post(`/api/payment1/stripe/checkout/create-checkout-session/subscription/si/new/${priceId}/${email}`, null );
    }

    async createStripeCheckoutSessionExistingClient(priceId, email, clientDto) {
        return await axios.post(`/api/payment1/stripe/checkout/create-checkout-session/subscription/si/existing/${priceId}/${email}`, clientDto );
    }

    async createStripeCheckoutSessionExistingClientKitrin(companyId, priceId, plan) {
        return await axios.post(`/api/payment1/stripe/checkout/create-checkout-session/subscription/kitrin/existing/${companyId}/${priceId}/${plan}`, null );
    }

    async getCompanyOnlinePaymentsLazyLoading(companyId, params, search, filters, start, end) {
        try {
            const newParams = {};

            newParams.sort  = params.sortField || 'created';
            newParams.order = params.sortOrder === 1 ? 'asc' : 'desc';

            newParams.page = params.first / params.rows + 1;
            newParams.size = params.rows;

            if (search) {
                newParams.search = search;
            }

            if (filters) {
                newParams.filters = filters;
            }

            if (start) {
                newParams.start = new Date(start).toISOString();
            }

            if (end) {
                newParams.end = new Date(end).toISOString();
            }

            var apiString = `/api/payment1/online/lazyloading/${companyId}`;

            console.log("[PaymentService][getCompanyOnlinePaymentsLazyLoading] ",
                "page =", newParams.page,
                ", size =", newParams.size,
                ", sort =", newParams.sort,
                ", order =", newParams.order,
                ", search =", newParams.search,
                ", filters =", newParams.filters,
                ", start =", newParams.start,
                ", end =", newParams.end,
                ", API =", apiString);

            const response = await axios.get(apiString, {
                headers: authHeader(),
                params: newParams
            });

            return {
                data: response.data,
                totalRecords: response.totalElements
            };
        } catch (error) {
            console.error("[InvoiceService][getCompanyOnlinePaymentsLazyLoading] API Error = ", error);
            return { data: [], totalRecords: 0 };
        }
    }

    async refundOnlineGBPPayment(companyId, id) {
        return await axios.post(`/api/payment1/online/refund/gbp/${companyId}/${id}`, null, { headers: authHeader() });
    }
}

export default new PaymentService();
